/**
 * Krunchie Naturals — Hero Video Loader
 * ─────────────────────────────────────────────────────────────
 * Videos are now managed from the Shopify Theme Editor.
 *
 * HOW TO ADD / CHANGE VIDEOS:
 *   1. In the Theme Editor, click the "Hero" section in the left panel
 *   2. You'll see an "Add block" button — click it and choose "Hero Video"
 *   3. Upload your .mp4 file using the file picker that appears
 *   4. Repeat for each video you want to rotate through (max 5)
 *   5. Save — done. One video is picked at random on each page load.
 *
 * VIDEO RECOMMENDATIONS:
 *   Format     : MP4 (H.264)
 *   Resolution : 1080x1350 (portrait 4:5) or 1080x1080
 *   Duration   : 6–15 seconds
 *   File size  : Under 8MB for fast mobile loading
 *   Audio      : Not needed (autoplay requires muted)
 * ─────────────────────────────────────────────────────────────
 */

(function () {
  'use strict';

  /*
   * Video source: prefer window.KRUNCHIE_HERO_VIDEOS injected by
   * sections/hero.liquid (populated from Theme Editor blocks).
   * Falls back to FALLBACK_VIDEOS for local dev / if no blocks added yet.
   */
  var FALLBACK_VIDEOS = [
    /*
     * Add fallback filenames here only if you want them as a backup
     * when no videos are configured in the Theme Editor.
     * Example:
     * { mp4: 'videos/dog-counter-carrots.mp4', label: 'Carrots' },
     */
  ];

  function getVideoList() {
    var editorVideos = window.KRUNCHIE_HERO_VIDEOS;
    if (Array.isArray(editorVideos) && editorVideos.length > 0) {
      // Filter out any empty entries (block added but no file uploaded yet)
      return editorVideos.filter(function(v) {
        return v && v.mp4 && v.mp4.trim() !== '';
      });
    }
    return FALLBACK_VIDEOS;
  }

  function pickRandom(list) {
    if (!list.length) return null;
    return list[Math.floor(Math.random() * list.length)];
  }

  function loadVideo(videoData) {
    var el = document.getElementById('heroVideo');
    if (!el || !videoData) return;

    // Clear any previously injected sources
    while (el.firstChild) el.removeChild(el.firstChild);

    var mp4 = document.createElement('source');
    mp4.src  = videoData.mp4;
    mp4.type = 'video/mp4';
    el.appendChild(mp4);

    el.load();
    el.play().catch(function () {
      // Autoplay blocked — poster frame will show instead
    });
  }

  function init() {
    var videos = getVideoList();
    var chosen = pickRandom(videos);

    if (chosen) {
      loadVideo(chosen);
    }
    // If no videos configured, the poster image set in Theme Editor shows instead
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
